<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  reportName="MonthlyWorkInformation"
  (valueChangeByApiName)="onValueChangeByApiName($event)"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [noSubmit]="true">
  <ng-container class="content">
    <editable-grid
      *ngIf="HrmPersonnelElementInitials && HrmPersonnelElementInitials.length > 0"
      [isAdd]="false"
      [isDelete]="false"
      [isEdit]="true"
      rowEditableKeyNotAllow="HasCalculate"
      [columns]="dColumns"
      [height]="60"
      (afterSaved)="onValueChanges($event)"
      [(dataList)]="HrmPersonnelElementInitials">
    </editable-grid>
  </ng-container>
</dynamic-form>
